import { Middleware } from "@reduxjs/toolkit";

let lastSavedSerialized: string | null = null;
let lastStoreDataRef: any = null;
let saveTimeout: any = null;

const SAVE_DELAY = 200;

const storeDataMiddleware: Middleware = store => next => action => {
    const result = next(action);

    const storeData = store.getState().storeData;

    if (storeData === lastStoreDataRef) return result;
    lastStoreDataRef = storeData;

    const data = storeData?.data || {};
    const newData: Record<string, string> = {};

    for (const key in data) {
        const value = data[key];
        if (value?._id) newData[key] = String(value._id);
    }

    if (storeData?.initialLoad || Object.keys(newData).length === 0) {
        return result;
    }

    try {
        const serialized = JSON.stringify(newData);

        if (serialized === lastSavedSerialized) return result;

        clearTimeout(saveTimeout);
        saveTimeout = setTimeout(() => {
            localStorage.setItem("storeData", serialized);
            lastSavedSerialized = serialized;
        }, SAVE_DELAY);
    } catch (error) {
        console.error("Error saving store data:", error);
    }

    return result;
};

export default storeDataMiddleware;
